module.exports = __webpack_public_path__ + "static/media/oldrow.84b4b695.jpg";